import { CircleQuestionMark } from "lucide-react";

import { InfoSection } from "./components/InfoSection";

export const InfoFAQ = () => {
  return (
    <InfoSection icon={CircleQuestionMark} title="FAQ">
      <ul className="list-disc text-default-800 ml-10 flex flex-col gap-1">
        <li>
          <p>Why are my pixels misaligned?</p>
          <p className="text-default-600">
            This is due to browser zoom. The typical keybind to reset this is
            ctrl/cmd + zero
          </p>
        </li>
      </ul>
    </InfoSection>
  );
};
